import React, { useContext } from 'react';
import { Grid } from '@material-ui/core';
import { Box } from '@mui/material';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import Link from '@mui/material/Link';
import AccountCircleSharpIcon from '@mui/icons-material/AccountCircleSharp';
import { roleContext } from '../../context/RoleContext';
import DashboardSharpIcon from '@mui/icons-material/DashboardSharp';
import BookOnlineIcon from '@mui/icons-material/BookOnline';
import { UserRole } from '../../types/role';
import { Link as RouterLink } from 'react-router-dom';
import { useLogout } from '../../hooks/useLogout';

const SideMenu = () => {
  const role = useContext(roleContext);
  const doLogout = useLogout();
  return (
    <Grid
      component={Box}
      sx={{
        ml: 0,
        mt: 0,
      }}
    >
      <Box style={{ position: 'fixed' }}>
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          sx={{
            backgroundColor: 'white',
            width: '250px',
            borderRadius: '10px',
          }}
          subheader={
            <ListSubheader
              component="div"
              id="nested-list-subheader"
              sx={{
                fontSize: 12,
                fontWeight: 'bold',
              }}
            >
              Home
            </ListSubheader>
          }
        >
          <Link
            component={RouterLink}
            to={'/dashboard'}
            color={'inherit'}
            underline={'none'}
          >
            <ListItemButton>
              <ListItemIcon>
                <DashboardSharpIcon />
              </ListItemIcon>
              <ListItemText primary={'Dashboard'} />
            </ListItemButton>
          </Link>
          <Link
            component={RouterLink}
            to={'/reservation-manager'}
            color={'inherit'}
            underline={'none'}
          >
            <ListItemButton>
              <ListItemIcon>
                <BookOnlineIcon />
              </ListItemIcon>
              <ListItemText primary={'Reservation Manager'} />
            </ListItemButton>
          </Link>
          <Link
            component={RouterLink}
            to={'/calendar-manager'}
            color={'inherit'}
            underline={'none'}
          >
            <ListItemButton>
              <ListItemIcon>
                <CalendarMonthOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary={'Schedule Manager'} />
            </ListItemButton>
          </Link>
          <Link
            component={RouterLink}
            to={'/services'}
            color={'inherit'}
            underline={'none'}
          >
            <ListItemButton>
              <ListItemIcon>
                <AccountCircleSharpIcon />
              </ListItemIcon>
              <ListItemText primary={'Profile'} />
            </ListItemButton>
          </Link>

          <Link
            component={RouterLink}
            to={'/account-settings'}
            color={'inherit'}
            underline={'none'}
          >
            <ListItemButton>
              <ListItemIcon>
                <AccountCircleSharpIcon />
              </ListItemIcon>
              <ListItemText primary={'Account'} />
            </ListItemButton>
          </Link>
          {role !== UserRole.SHOP_BARBER && (
            <Link
              component={RouterLink}
              to={'/subscription-details'}
              color={'inherit'}
              underline={'none'}
            >
              <ListItemButton>
                <ListItemIcon>
                  <LoyaltyIcon />
                </ListItemIcon>
                <ListItemText primary={'Subscription Manager'} />
              </ListItemButton>
            </Link>
          )}
          <ListItemButton onClick={() => doLogout()}>
            <ListItemIcon>
              <LockOpenIcon />
            </ListItemIcon>
            <ListItemText primary={'Logout'} />
          </ListItemButton>
        </List>
      </Box>
    </Grid>
  );
};

export default SideMenu;
